
//--------------------------------------------------------------------------------------------
// ftdialog jquery plugin
// Wraps jqueryUI dialog to provide sensible defaults and other behavior
//
(function($) {

    var addClass = function(existing, toAdd) 
    {
        if (existing == null)
            existing = '';

        return jQuery.trim(existing + ' ' + toAdd);
    };

    $.fn.jqdialog = $.fn.dialog;

    $.fn.ftdialog = function(options) {
        
        var $this = $(this);
        if (typeof(options) === 'object' || !options)
        {
            // default settings defined by the markup
            var settings = {
                clickaway: $this.hasClass('clickaway'),
                title: $this.attr('title')
            };
            settings = $.extend(settings, $.fn.ftdialog.defaults, options);
            var open = settings.open;
            if (typeof(open) !== 'function')
                open = jQuery.noop;

            if (settings.clickaway) 
            {
                settings.open = function(event, ui) {
                    $('.ui-widget-overlay').click(function () { $this.jqdialog('close'); });
                    open.apply(this, arguments);
                };
            }
            // hide the title bar when the title is set to null
            if (settings.title == null) 
                settings.dialogClass = addClass(settings.dialogClass, 'notitle');

            return $this.jqdialog.call(this, settings);
        }

        return $this.jqdialog.apply(this, arguments);
    };

    $.fn.ftdialog.defaults = {
        autoOpen: false,
        modal: true,
        resizable: false,
        show: { effect: 'fade', duration: 'fast' }
    };

    // overwrite jquery's dialog
    $.fn.dialog = $.fn.ftdialog;

})(jQuery);
